import PropTypes from 'prop-types';
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("React Error Boundary caught an error:", error, errorInfo);
        this.setState({ errorInfo });

        // Optional: report to error tracking service
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback ? (
                this.props.fallback(this.state.error, this.state.errorInfo)
            ) : (
                <div className="error-boundary p-4 m-3 border rounded" style={{ backgroundColor: '#fff8f8', borderColor: '#ffcccc' }}>
                    <h2 className="text-danger mb-3">Bir şeyler yanlış gitti.</h2>
                    <p className="mb-3">Bu bileşen bir hata ile karşılaştı. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.</p>
                    {this.props.showDetails && (
                        <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                            <summary>Hata Detayları</summary>
                            <p>{this.state.error && this.state.error.toString()}</p>
                            <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
                        </details>
                    )}
                    {this.props.showResetButton && (
                        <button
                            className="btn btn-outline-danger mt-3"
                            onClick={() => {
                                this.setState({ hasError: false, error: null, errorInfo: null });
                                if (this.props.onReset) {
                                    this.props.onReset();
                                }
                            }}
                        >
                            Yeniden Dene
                        </button>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.func,
    onError: PropTypes.func,
    onReset: PropTypes.func,
    showDetails: PropTypes.bool,
    showResetButton: PropTypes.bool
};

ErrorBoundary.defaultProps = {
    showDetails: process.env.NODE_ENV === 'development',
    showResetButton: true
};

export default ErrorBoundary; 